import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PORTAL_URL } from '../config/links';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from '../context/LanguageContext';
import './Navbar.css';

const navLinks = [
  { label: 'Home', labelKey: 'agency.nav_home_label', path: '/' },
  { label: 'Training', labelKey: 'agency.nav_training_label', path: '/training' },
  { label: 'Staff Augmentation', labelKey: 'agency.nav_staff_augmentation_label', path: '/staff-augmentation' },
  { label: 'IT Services', labelKey: 'agency.nav_it_services_label', path: '/it-services' },
  { label: 'Enterprise AI', labelKey: 'agency.nav_enterprise_ai_label', path: '/enterprise-ai' },
  { label: 'Jobs', labelKey: 'agency.nav_jobs_label', path: '/jobs' },
  { label: 'Contact Us', labelKey: 'agency.nav_contact_us_btn', path: '/contact', className: 'nav-link-accent' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

useEffect(() => { setMenuOpen(false); }, [location]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar" ref={menuRef}>
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img src="/logo.png" alt="ThirdEye Cybersecurity" className="brand-logo" />
          <div className="brand-text">
            <span className="brand-name">ThirdEye</span>
            <span className="brand-sub">Cybersecurity</span>
          </div>
        </Link>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {navLinks.map(link => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`nav-link ${link.className || ''} ${location.pathname === link.path ? 'active' : ''}`}
              >
                {t(link.labelKey, link.label)}
              </Link>
            </li>
          ))}
          <li>
            <a
              href={PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-login"
            >
              {t('agency.nav_login_btn', 'Log In')} <span aria-hidden="true">↗</span>
            </a>
          </li>
          <li>
            <a
              href={PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-portal-link"
            >
              <svg className="nav-portal-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
              </svg>
              {t('agency.nav_learning_portal_btn', 'Learning Portal')} <span aria-hidden="true">↗</span>
            </a>
          </li>
          <li className="nav-lang-inline">
            <LanguageSwitcher />
          </li>
        </ul>

        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={t('agency.nav_toggle_navigation_label', 'Toggle navigation')}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Wide screens: pinned to the far right edge of the page, outside the container */}
      <div className="nav-lang-edge">
        <LanguageSwitcher />
      </div>
    </nav>
  );
}
